import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取广告位分页
 * @param data
 *
 */
export const getAdvertisingPage = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/page',
    method: 'POST',
    data
  })
}
/**
 * 保存或更新广告位
 * @param data
 *
 */
export const saveOrUpdate = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/saveOrUpdate',
    method: 'POST',
    data
  })
}
/**
 * 获取广告位详情
 * @param data
 *
 */
export const getInfo = (id) => {
  return request({
    url: env.ferryUrl + `/advertising/getInfo/${id}`,
    method: 'GET'
  })
}
/**
 * 修改广告位状态
 * @param data
 *
 */
export const changeStatus = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/changeStatus',
    method: 'POST',
    data
  })
}
/**
 * 获取系统广告位位置配置
 * @param data
 *
 */
export const advertisingLocation = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/advertising-Location',
    method: 'GET'
  })
}
/**
 * 获取系统广告位位置配置
 * @param data
 *
 */
export const advertisingDataFetch = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/page/data',
    method: 'POST',
    data
  })
}

/**
 * 广告位列表接口
 * @param data
 *
 */
export const advertisingList = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/list',
    method: 'POST',
    data
  })
}

/**
 * icon图标分页
 * @param data
 *
 */
export const iconPage = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/icon/page',
    method: 'POST',
    data
  })
}

// 更新icon排序
export const iconUpdateSort = (params) => {
  return request({
    url: env.ferryUrl + '/advertising/iconUpdateSort',
    method: 'PUT',
    data: params
  })
}
// 保存icon图标
export const iconSave = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/icon/save',
    method: 'POST',
    data
  })
}
// 删除icon图标
export const iconRemove = (id) => {
  return request({
    url: env.ferryUrl + `/advertising/icon/remove/${id}`,
    method: 'DELETE'
  })
}

/**
 * 修改icon配置
 */
export const changeLayout = (data) => {
  return request({
    url: env.ferryUrl + '/advertising/icon/layout/status',
    method: 'put',
    data
  })
}

/**
 * 获取布局配置
 */
export const getIconLayout = () => {
  return request({
    url: env.ferryUrl + '/advertising/icon/layout',
    method: 'get'
  })
}

/**
 * 获取页面配置字典
 */
export const getPageEnumList = () => {
  return request({
    url: env.ferryUrl + '/advertising/enums',
    method: 'get'
  })
}
